import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, SmsFirmOptions } from "../../../../../_helpers/Helpers";

export function SMSAccountForm({
  handleChange,
  setFieldValue,
  values
 }) {
  return (
    <>
      <Form.Group as={Row} controlId="smsFirm">
        <Form.Label column sm={4}>
          SMS Firması
        </Form.Label>
        <Col sm={8}>
          <CustomSelect
            options={SmsFirmOptions}
            value={values.smsFirm}
            onChange={option => setFieldValue("smsFirm", option.value)}
          />
        </Col>
      </Form.Group>
                    
      <Form.Group as={Row} controlId="smsUsername">
        <Form.Label column sm={4}>
          Kullanıcı Adı
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="text" value={values.smsUsername} placeholder="Kullanıcı Adı" onChange={handleChange} />
        </Col>
      </Form.Group>
                    
      <Form.Group as={Row} controlId="smsPassword">
        <Form.Label column sm={4}>
          Şifre
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="text" value={values.smsPassword} placeholder="Şifre" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="smsOriginator">
        <Form.Label column sm={4}>
          Orjinatör
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="text" value={values.smsOriginator} placeholder="Orjinatör" onChange={handleChange} />
        </Col>
      </Form.Group>
    </>        
  );
}